import env from '../env';

type Props = { redirect?: string };

/**
 * Format and go to login url with correct parameters
 */
export const register = ({ redirect }: Props) => {
  const current = new URL(redirect ?? window.location.href);

  // get the source from the url
  const source = current.searchParams.get('source');

  window.location.href = `${env.PATH_PREFIX}/register?source=${source || current.toString()}`;
};

export default register;
